'use strict';

angular.module('shiftTraderApp')
    .directive('saAvailability', ['UserPermissionsService', function(UserPermissionsService) {
      return {
        templateUrl: 'views/directives/saAvailability.html',
        restrict: 'A',
        scope: {
          me: '=',
          user: '='
        },
        link: function postLink(scope, element) {


          UserPermissionsService.can('availability_sets.view_target', 'current')
            .then(function(result) {
            scope.canShowTarget = result;
          });

          // TODO: handle not finding a set down below this
          scope.currentSet = _.find(scope.user.availability_sets, function(availSet) {
            return availSet.$isInEffect() && availSet.$isApproved();
          });

          scope.futureSet = _.find(scope.user.availability_sets, function(availSet) {
            return !availSet.$isInEffect() && availSet.$isApproved();
          });

          scope.inReviewSet = _.find(scope.user.availability_sets, function(availSet) {
            return availSet.$isInReview() && availSet.active;
          });

          scope.state = {
            showing: 'current'
          };

          scope.setShow = function(name) {
            scope.state.showing = name;
          };
        }
      };
    }]);
